// Constants for different requests for current reducer
export default {
  attachments: 'ATTACHMENTS',
};
